<template>
  <div :class="['modal', { 'modal--is-active': store.errors.modal }]">
    <div class="modal__background"></div>
    <div class="modal__main">
      <div class="modal__container" v-if="errorTitle !== ''">
        <h2 class="modal__title">{{ errorTitle }}</h2>
        <div class="modal__info">
          <p class="modal__error pb-5 mb-0" v-if="errorText !== ''">
            {{ errorText }} <span v-if="user.department.phone !== undefined">{{ extendedErrorText }} {{ phoneNumberText }}</span>
          </p>
          <p class="pt-0 pb-0 mb-0" v-if="user.department.contactemail !== undefined && store.errors.data.tokenexpired === ''">
            <v-text-field solo required name="userPhone" :label="errorPlaceholder" maxlength="255" v-model="userPhone" type="number"> </v-text-field>
          </p>
          <h3 class="modal__name pt-0 pb-0 mb-0" v-if="user.department.name !== undefined && store.errors.data.tokenexpired === ''">
            {{ user.department.name }}
          </h3>
          <p class="modal__address pt-1 pb-0 mb-0" v-if="user.department.address !== undefined && store.errors.data.tokenexpired === ''">
            {{ user.department.address }}, {{ user.department.zipcode }} {{ user.department.city }}
          </p>
          <p class="modal__phone pt-1 pb-0 mb-0" v-if="user.department.phone !== undefined && store.errors.data.tokenexpired === ''">
            {{ $t('general.words.phone') }}: <a :href="'tel:' + user.department.phone">{{ user.department.phone }}</a>
          </p>
          <p class="modal__email pt-1 pb-0 mb-0" v-if="user.department.contactemail !== undefined && store.errors.data.tokenexpired === ''">
            {{ $t('general.words.email') }}: <a :href="'mailto:' + user.department.contactemail">{{ user.department.contactemail }}</a>
          </p>
        </div>
        <div
          :class="[
            'modal__button-container pt-3',
            { 'modal__button-container--single': store.errors.data.tokenexpired !== '' || store.errors.data.general !== '' }
          ]"
        >
          <button
            v-if="store.errors.data.tokenexpired === ''"
            class="modal__button v-btn v-btn--contained v-btn--rounded v-size--large primary"
            @click="doPageRefresh"
          >
            {{ $t('button.pageRefresh') }}
          </button>
          <button
            v-if="user.department.contactemail !== undefined || store.errors.data.tokenexpired !== ''"
            :class="[
              'modal__button v-btn v-btn--contained v-btn--rounded v-size--large theme--light primary',
              { 'v-btn--disabled': userPhone === '' && store.errors.data.tokenexpired === '' }
            ]"
            :disabled="userPhone === '' && store.errors.data.tokenexpired === ''"
            @click="modalButton"
          >
            <span v-if="store.errors.data.tokenexpired === ''">{{ $t('button.phoneSend') }}</span>
            <span v-if="store.errors.data.tokenexpired !== ''">{{ $t('button.renewToken') }}</span>
          </button>
        </div>
        <p class="modal__traceid pt-5 pb-0 mb-0">{{ user.guid }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('user');
import localizationTexts from '@/localization/texts.json';
import helpers from '@/settings/helpers.js';

export default Vue.extend({
  name: 'ModalError',
  computed: {
    store() {
      return helpers.getter(this.$store.getters);
    },
    ...mapGetters(['user']),
    foo() {
      return this.userPhone === undefined;
    }
  },
  data() {
    return {
      errorPlaceholder: 'Indtast dit telefonnummer',
      userPhone: '',
      errorTitle: '',
      errorText: '',
      phoneNumberText: '',
      extendedErrorText: '',
      emailSubject: '',
      emailText: ''
    };
  },
  mounted() {
    this.errorPlaceholder = localizationTexts[this.user.config.language].general.sentences.submitPhoneNumber;
    this.errorTitle = localizationTexts[this.user.config.language].errors.UnknownErrorOccured.title;
    this.errorText = localizationTexts[this.user.config.language].errors.UnknownErrorOccured.description;
    this.phoneNumberText = localizationTexts[this.user.config.language].errors.UnknownErrorOccured.phoneNumberText;
    this.extendedErrorText = localizationTexts[this.user.config.language].errors.UnknownErrorOccured.extendedDescription;
    this.emailSubject = localizationTexts[this.user.config.language].general.sentences.emailSubject;
    this.emailText = localizationTexts[this.user.config.language].general.sentences.emailText;
  },
  updated() {
    if (this.store.errors.data.tokenexpired !== '') {
      this.extendedErrorText = '';
      this.phoneNumberText = '';
      this.errorTitle = localizationTexts[this.user.config.language].errors.TokenExpiredError.title;
      this.errorText = localizationTexts[this.user.config.language].errors.TokenExpiredError.description;
    }
  },
  methods: {
    doPageRefresh() {
      helpers.sendRefresh(this.user.config.host);
    },
    modalButton() {
      if (this.store.errors.data.tokenexpired !== '') {
        if (this.store.errors.data.tokenexpired === 'TOKEN_EXPIRED_1') {
          // refresh token
          const payload = {
            endpoint: this.user.config.parameters.api + '/authentication/GetToken',
            params: {
              rooftopid: this.user.selectedRooftopid !== '' ? this.user.selectedRooftopid : this.user.rooftopids[0],
              traceid: this.user.guid,
              test: this.user.config.parameters.parameters.test
            }
          };
          this.$store.dispatch('user/initToken', payload).then(() => {
            // close modal
            this.store.errors.modal = false;
          });
        } else {
          helpers.sendRefresh(this.user.config.host);
        }
      } else if (
        this.store.errors.data.general !== '' ||
        this.store.errors.data.car !== '' ||
        this.store.errors.data.departments !== '' ||
        this.store.errors.data.dates !== '' ||
        this.store.errors.data.options !== '' ||
        this.store.errors.data.times !== '' ||
        this.store.errors.data.appointment !== '' ||
        this.store.errors.data.other !== ''
      ) {
        let payload = {
          endpoint: this.user.config.parameters.api + '/department/contact',
          data: {
            rooftopid: this.user.selectedRooftopid,
            phone: this.userPhone,
            registrationplate: this.user.registrationplate,
            traceid: this.user.guid,
            emailsubject: this.emailSubject,
            emailtext: this.emailText
          }
        };
        this.$store.dispatch('errors/submitPhone', payload).then(() => {
          this.$store.dispatch('user/initLoading', false);
          helpers.sendRefresh(this.user.config.host);
        });
      } else {
        helpers.sendRefresh(this.user.config.host);
      }
    },
    modalSend() {},
    onKeyDown(evt) {
      if (evt.target.value == undefined) return;
      this.userPhone = evt.target.value;
    }
  }
});
</script>

<style scoped lang="scss">
.modal {
  // position: fixed; //Quick fix, to make sure modal height is considered for widget height. Result in modal overlay only affecting widget which will be visible when not running widget through connector.
  top: 0;
  left: 0;
  width: 0px;
  height: 0px;
  z-index: 998;
  pointer-events: none;

  &__background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: black;
    opacity: 0;
    transition: opacity 0.3s;
    transition-delay: 0.3s;
  }
  &__main {
    position: fixed;
    z-index: 999;
    overflow: visible;
    top: 50%;
    left: 50%;
    width: 100%;
    height: auto;
    max-width: 600px;
    max-height: 100%;
    transform: translate(-50%, -75%);
    background: white;
    padding: 2rem;
    border-radius: 10px;
    box-shadow: 5px 5px 10px -3px #000;
    opacity: 0;
    transition: opacity 0.3s, transform 0.3s;
    transition-delay: 0s;
  }

  &__info {
    strong {
      font-weight: 700;
    }
  }

  &__title {
    text-align: center;
    padding: 0 0 20px;
    margin: 0;
  }

  &__button-container {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;

    &--single {
      display: block;
      text-align: center;
    }
  }

  &__traceid {
    text-align: center;
    color: #808080;
    font-size: 0.5em;
    padding: 0 0 20px;
    margin: 0;
  }

  &--is-active {
    pointer-events: all;

    .modal {
      &__background {
        opacity: 0.5;
        transition-delay: 0s;
      }
      &__main {
        opacity: 1;
        transform: translate(-50%, -50%);
        transition-delay: 0.3s;
      }
    }
  }
}
</style>

<i18n src="../localization/texts.json"></i18n>
